import { DevFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';

export function isOrganizationViewEnabled(context: IAuthorizationContext) {
  return context.hasAdminAccess();
}
export function isWorkOrderViewEnabled(
  context: IAuthorizationContext,
): boolean {
  return context.featureChecker.devFeatureEnabled(DevFeatures.WorkOrder);
}
